const faqs = [
    {
        question: 'Do I really need weekly maintenance services for my swimming pool?',
        answer: 'Weekly maintenance and cleaning is required to keep your pool safe and clean. Whether or not you need the full range of services Crystal Clear Pool & Spa Service provides really depends on how much time and effort you are willing to spend on your swimming pool yourself. If your only interest is to be able to jump in at any given time, then you probably want to consider getting the full service package.',
        id: 'faq1'
    },
    {
        question: 'Is there any way to prevent stains in my pool?',
        answer: 'Absolutely! Stains in your pool are caused by metals and minerals that come in contact with the water. Crystal Clear Pool & Spa Service can help reduce the appearance of stains in your pool by introducing sequestering agents in your swimming pool, which serve to pull these metals and minerals out of the water.',
        id: 'faq2'
    },
    {
        question: 'Why do I need a pool heater?',
        answer: "You don't. Heaters are not necessary for you to fully enjoy your swimming pool. They do, however, extend your pool-using days considerably, warming up your swimming pool a lot faster (and sooner) than heat covers. They also allow you to continue using your swimming pool later in the season, when the sun isn't always warm enough to do the job.",
        id: 'faq3'
    }
];

export default faqs;